import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getStrengtheningData(context) {
      const response = await Vue.axios.get(`${URL_API}strengtheningtype`);
      let data = response["data"];
      context.commit("updateStrengtheningData", data);
    },
    async createStrengtheningData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}strengtheningtype/store`, body, config);
      context.dispatch("getStrengtheningData");
    },
    async pushStrengtheningData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}strengtheningtype/update`, body, config);
      context.dispatch("getStrengtheningData");
    },
    async destroyStrengtheningData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}strengtheningtype/destroy`, body, config);
      context.dispatch("getStrengtheningData");
    }
  },
  mutations: {
    updateStrengtheningData(state, strengtheningData) {
      state.strengtheningData = strengtheningData;
    }
  },
  state: {
    strengtheningData: []
  },
  getters: {
    allStrengtheningData(state) {
      return state.strengtheningData;
    }
  }
};